if (!customElements.get('davie-empty-product-reviews')) {
  customElements.define('davie-empty-product-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.discoveryObserver) return;
      this.discoveryObserver = new MutationObserver(() => this.findRoot());
      this.findRoot();
    }

    disconnectedCallback() {
      this.discoveryObserver?.disconnect();
      this.discoveryObserver = null;
      this.releaseRoot();
    }

    findRoot() {
      if (!this.isConnected || !this.discoveryObserver) return;
      const root = document.getElementById('vitals-end-section');
      if (root && root === this.appRoot && root.parentElement === this.rootParent) return;
      this.releaseRoot();
      if (!root) {
        this.discoveryObserver.observe(document.body, { childList: true, subtree: true });
        return;
      }
      this.discoveryObserver.disconnect();
      this.appRoot = root;
      this.rootParent = root.parentElement;
      this.rootObserver = new MutationObserver(() => this.syncWidget());
      this.rootObserver.observe(root, { childList: true });
      if (this.rootParent) {
        this.parentObserver = new MutationObserver(() => {
          if (!this.appRoot?.isConnected || this.appRoot.parentElement !== this.rootParent) this.findRoot();
        });
        this.parentObserver.observe(this.rootParent, { childList: true });
      }
      this.syncWidget();
    }

    releaseRoot() {
      this.rootObserver?.disconnect();
      this.parentObserver?.disconnect();
      this.widgetObserver?.disconnect();
      this.restoreWidget();
      this.rootObserver = null;
      this.parentObserver = null;
      this.widgetObserver = null;
      this.widget = null;
      this.appRoot = null;
      this.rootParent = null;
    }

    restoreWidget() {
      if (this.widget?.getAttribute('data-davie-confirmed-empty-reviews') === 'art-product') {
        this.widget.removeAttribute('data-davie-confirmed-empty-reviews');
      }
    }

    syncWidget() {
      if (!this.isConnected || !this.appRoot) return;
      const widget = this.appRoot.querySelector(':scope > .vtl-pr-main-widget.vtl-pr-main-widget--product-page');
      if (widget !== this.widget) {
        this.widgetObserver?.disconnect();
        this.restoreWidget();
        this.widget = widget;
        if (widget) {
          this.widgetObserver = new MutationObserver(() => this.updateVisibility());
          this.widgetObserver.observe(widget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
        }
      }
      this.updateVisibility();
    }

    updateVisibility() {
      const widget = this.widget;
      if (!this.isConnected || !widget) return;
      const totals = widget.querySelectorAll('.vtl-pr-totals__reviews');
      const scores = widget.querySelectorAll('.vtl-pr-totals__score');
      const states = widget.querySelectorAll('.vtl-pr-stats');
      const emptySummaries = widget.querySelectorAll('.vtl-pr-main-widget__summary-no-reviews');
      const count = totals.length === 1 ? totals[0].querySelector(':scope > span') : null;
      const score = scores.length === 1 ? scores[0] : null;
      const confirmedEmptyState = states.length === 1
        && states[0].matches('.vtl-pr-stats--no-reviews')
        && emptySummaries.length === 1
        && states[0].contains(emptySummaries[0]);
      const confirmedEmpty = widget.parentElement === this.appRoot
        && widget.matches('.vtl-pr-main-widget.vtl-pr-main-widget--product-page')
        && count?.textContent.trim() === '0'
        && score?.textContent.trim() === '0'
        && confirmedEmptyState;
      if (confirmedEmpty) {
        widget.setAttribute('data-davie-confirmed-empty-reviews', 'art-product');
      } else {
        this.restoreWidget();
      }
    }
  });
}
